import { useEffect } from "react";
import cookie from 'react-cookies';
import { useState } from "react";

const CronRecords = () => {
    return (
        <div>敬请期待！</div>
    )
}
export default CronRecords;